import { useState, useEffect } from 'react';
import rym from '../assets/rym.jpeg';

const HomeAboutSection = ({ setCurrentPage }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const element = document.getElementById('home-about');
      if (element) {
        const rect = element.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.75) {
          setIsVisible(true);
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section id="home-about" className="py-20 px-4 bg-white relative overflow-hidden">
      <div className="max-w-6xl mx-auto">
        <div className="md:flex items-center">
          <div className={`md:w-1/2 mb-12 md:mb-0 md:pr-12 transition-all duration-1000 ease-out ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-20'}`}>
            <h2 className="text-4xl font-bold text-gray-900 mb-6 leading-tight">
              Bienvenido a <span className="text-red-600">R&M Componentes Industriales</span>
            </h2>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              Somos una empresa dedicada a brindar <span className="font-semibold">soluciones confiables y de alto nivel</span>, 
              comprometidos en ofrecer productos y servicios que impulsen la competitividad de la industria, 
              asegurando eficiencia en los procesos, innovación tecnológica y un respaldo especializado en cada proyecto.
            </p>
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              En R&M encontrarás un <span className="font-semibold">aliado estratégico</span> que entiende tus necesidades, 
              trabaja con marcas líderes y ofrece un servicio integral diseñado para optimizar tu producción 
              y llevar tu negocio al siguiente nivel.
            </p>
            <button 
              onClick={() => { setCurrentPage('about'); }} 
              className="bg-gray-800 hover:bg-gray-900 text-white font-bold py-3 px-8 rounded-full text-lg transition-all duration-300 transform hover:scale-105 shadow-md hover:shadow-lg"
            >
              Conoce más de nuestra historia
            </button>
         </div>

          <div className={`md:w-1/2 relative transition-all duration-1000 ease-out delay-200 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-20'}`}>
            <img 
              src={rym}
              alt="Instalaciones de R&M Componentes Industriales"
              className="rounded-xl shadow-2xl w-full h-auto transform rotate-3 hover:rotate-0 transition-transform duration-500"
            />
            <div className="absolute -bottom-4 -left-4 w-32 h-32 bg-red-600 rounded-full mix-blend-multiply filter blur-xl opacity-30 animate-blob"></div>
            <div className="absolute -top-8 -right-8 w-48 h-48 bg-blue-600 rounded-full mix-blend-multiply filter blur-xl opacity-30 animate-blob animation-delay-2000"></div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default HomeAboutSection;